module.exports = __webpack_public_path__ + "img/pi-4-3.358e9e44.jpg";